/*
 * File: ProceduresTable.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Table of procedures displayed at the bottom of the New Charge page
 */
import React from "react";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import { ListItemText, ListItem, List } from "@material-ui/core";
import { observer } from "mobx-react";
import { Instance } from "mobx-state-tree";
import SelectedDiagnosesStore from "../../store/SelectedDiagnosesStore";
import PostChargesModel from "../../store/PostChargesModel";
import ChargeModel from "../../store/ChargeModel";

interface Props {
  postChargeModel: Instance<typeof PostChargesModel>;
  editCharge: (chargeModel: Instance<typeof ChargeModel>) => void;
  selectedDiagnosisStore: Instance<typeof SelectedDiagnosesStore>;
}

const ProceduresTable = ({
  postChargeModel,
  editCharge,
  selectedDiagnosisStore
}: Props) => {
  const formatPointerString = (chargeModel: Instance<typeof ChargeModel>) => {
    const pointersArray: (string | undefined)[] = [];
    chargeModel.sortedDiagnoses.forEach(diagnosis => {
      if (diagnosis.toggledOn) {
        const pointerForDiagnosis = selectedDiagnosisStore.getPointerFromUmlsId(
          diagnosis.umlsId
        );
        pointersArray.push(pointerForDiagnosis);
      }
    });
    return "Pointers - " + pointersArray.join(", ");
  };

  return (
    <List>
      {postChargeModel.charges.map((chargeModel, idx) => {
        return (
          <ListItem key={idx}>
            <EditIcon onClick={() => editCharge(chargeModel)} />
            <ListItemText
              primary={chargeModel.procedure}
              secondary={formatPointerString(chargeModel)}
            />
            <CloseIcon
              onClick={() => postChargeModel.deleteCharge(chargeModel)}
            />
          </ListItem>
        );
      })}
    </List>
  );
};

export default observer(ProceduresTable);
